import React, { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'

import styles from './styles.module.css'
import InfoIcon from 'client/icons/Info'

import cn from 'classnames'

interface BookingStatusProps {
  location: string
  bookingStatus: string
  bookingInformation: Array<{ bookingStatus: string }>
  onClick: (type: string) => void
}

type BookingStatus = 'error' | 'unsolved' | 'confirmed' | 'pending' | 'cancelled'

const statusMap: Record<string, string> = {
  error: 'pending',
  unsolved: 'cancelled',
}

const VoucherBookingStatus = ({
  location,
  bookingInformation,
  onClick,
  children,
}: PropsWithChildren<BookingStatusProps>) => {
  const intl = useIntl()

  const bookingStatus = bookingInformation[0]?.bookingStatus
  const status = statusMap[bookingStatus as BookingStatus] || bookingStatus.toLowerCase()

  return (
    <div className={styles.container}>
      <div className={styles.statusContainer}>
        <p>
          {intl.formatMessage({
            id: 'global.booking-status',
          })}
          :{' '}
          <span className={cn(styles.status, styles[status])}>
            {intl.formatMessage({
              id: `global.booking-status-${status}-title`,
            })}
          </span>
        </p>
        <InfoIcon data-testid="info-icon" size={14} onClick={() => onClick('status')} />
      </div>

      {children}

      <h1>
        {intl.formatMessage(
          { id: 'global.booking-in-destination' },
          {
            destination: location,
          }
        )}
      </h1>
    </div>
  )
}

export default VoucherBookingStatus
